import { render } from "./add.vue?vue&type=template&id=eeaa7f8e"
import script from "./add.vue?vue&type=script&lang=js"
export * from "./add.vue?vue&type=script&lang=js"

import "./add.vue?vue&type=style&index=0&id=eeaa7f8e&lang=less"
script.render = render

export default script